module.exports = "#title-container {\n  padding-top: 11px;\n  padding-bottom: 15px; }\n\n#password {\n  margin-top: 1vw; }\n\n#forgot-password {\n  margin-top: 1.66vh;\n  font-size: 20px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #858585; }\n\n#back {\n  font-size: 20px; }\n\n.secondInputField {\n  margin-top: 15px; }\n\n#newPasswordSubmit {\n  margin-top: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/login/new-password/new-password.component.scss
// module id = ./src/app/shared/components/login/new-password/new-password.component.scss
// module chunks = main